import { Link } from 'react-router-dom'

export function PlaceholderPage({ eyebrow, title }: { eyebrow: string; title: string }) {
  return (
    <section className="placeholder-page container">
      <p className="eyebrow">Aldapa Systems / {eyebrow}</p>
      <h1>{title}</h1>
      <p>This route is ready for its dedicated design and content in the next phase.</p>
      <Link className="button button--light" to="/">Return home <span>→</span></Link>
    </section>
  )
}
